export const elektrikaCommodityGroups: string[] = [
    '23 - Pribor - Elektronika',
    'Elektro pribor',
    'Pribor - elektronika',
];

export function isMaterialColorable(
    commodityGroup: string | null | undefined
): boolean {
    if (!commodityGroup) return true;
    return !elektrikaCommodityGroups.includes(commodityGroup);
}